<template>
  <div class="screen_body" :class="bodyBg">
    <div class="screen_content">
      <div
        class="screen_main_03"
        v-if="
          screenFlow.StepId === '001' ||
          screenFlow.StepId === '002' ||
          screenFlow.StepId === '005'
        "
      >
        <h1>
          <div v-html="voteResultInfo.VoteName"></div>
        </h1>
        <div class="ranking ranking_box">
          <table>
            <tr
              v-for="(item, index) in voteResultInfo.VoteProjectList"
              :key="index"
            >
              <td>
                <div class="ranking-first ranking-item">
                  <div class="ranking-top">
                    <div class="ranking-ranking" style="width: 1rem">
                      {{ index + 1 }}、
                    </div>
                    <div class="ranking-project">{{ item.ProjectName }}</div>
                  </div>
                  <div class="ranking-company" style="margin-left: 1rem">
                    <div class="name">{{ item.Remark }}</div>
                    <div class="ranking_score_box">
                      <div
                        class="ranking_score_item"
                        v-for="(
                          stateItem, stateItemIndex
                        ) in item.ProjectStateList"
                        :key="stateItemIndex"
                      >
                        {{ stateItem.Value + '：' }}
                        <span>
                          {{ stateItem.VoteNumbers }}
                        </span>
                      </div>
                    </div>
                    <!-- <div class="score" v-if="item.TotalScore">
                      最终得分：<span>{{ item.TotalScore }}</span> 分
                    </div>
                    <div class="score" v-if="!item.TotalScore">
                      最终得分：未打分
                    </div> -->
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="height: 1.5rem"></div>
        </div>
      </div>
      <div
        class="screen_main_03"
        style="padding: 0px; width: 14rem"
        v-if="screenFlow.StepId === '003'"
      >
        <h1>
          <div v-if="completeResultInfo.CurrentVoteName.indexOf('--') !== -1">
            {{
              completeResultInfo.CurrentVoteName.substring(
                0,
                completeResultInfo.CurrentVoteName.indexOf('--')
              )
            }}
          </div>
          <div v-if="completeResultInfo.CurrentVoteName.indexOf('--') === -1">
            {{ completeResultInfo.CurrentVoteName }}
          </div>
        </h1>
        <div
          style="
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 10px 0px;
            margin-top: 1rem;
            font-size: 0.4rem;
          "
          v-for="(item, index) in completeResultInfo.ShortlistedAwardsList"
          :key="item.ProjectName + index"
        >
          <!-- <div style="width: 1rem; flex-shrink: 0; flex-grow: 0"></div> -->
          <div
            style="
              flex-shrink: 0;
              flex-grow: 1;
              display: -webkit-flex;
              display: flex;
              flex-direction: column;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div
              style="font-size: 0.52rem; max-width: 9rem; text-align: center"
            >
              {{ item.ProjectName }}
            </div>
            <div
              style="
                font-size: 0.45rem;
                font-family: kaiti;
                font-weight: bold;
                margin-top: 0.2rem;
              "
            >
              {{ item.Remark }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="screen_main_03"
        style="padding: 0px; width: 14rem"
        v-if="screenFlow.StepId === '006'"
      >
        <h1>
          <div v-if="completeResultInfo.CurrentVoteName.indexOf('--') !== -1">
            {{
              completeResultInfo.CurrentVoteName.substring(
                0,
                completeResultInfo.CurrentVoteName.indexOf('--')
              ) + '所在组最新排名情况'
            }}
          </div>
          <div v-if="completeResultInfo.CurrentVoteName.indexOf('--') === -1">
            {{ completeResultInfo.CurrentVoteName + '所在组最新排名情况' }}
          </div>
        </h1>
        <div
          style="margin: 50px 0px 0px 0px"
          v-for="(
            groupItem, groupIndex
          ) in completeResultInfo.SameGroupRankingList"
          :key="groupIndex"
        >
          <div style="padding: 10px 0px 40px 0px; text-align: center">
            {{ groupItem.GroupName }}
          </div>
          <div
            style="
              display: -webkit-flex;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: center;
              align-items: flex-start;
              font-size: 0.4rem;
              padding: 10px 0px;
            "
            v-for="(
              groupProjectItem, groupProjectItemindex
            ) in groupItem.ScreenVoteGroupRankingList"
            :key="groupProjectItemindex"
          >
            <div
              style="
                width: 1rem;
                flex-shrink: 0;
                flex-grow: 0;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-around;
                align-items: center;
              "
            >
              <!-- v-if="!groupProjectItem.ProjectTotalScore" -->
              <i
                class="el-icon-top"
                style="color: #e00022; font-weight: 900; margin-top: 4px"
              ></i>
              <span>{{ groupProjectItem.RankNum + '.' }}</span>
            </div>
            <div
              style="
                width: 10rem;
                flex-shrink: 0;
                flex-grow: 0;
                display: -webkit-flex;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: flex-start;
              "
            >
              <div>{{ groupProjectItem.ProjectName }}</div>
              <div
                style="
                  font-size: 0.32rem;
                  font-family: kaiti;
                  font-weight: bold;
                "
              >
                {{ groupProjectItem.ProjectRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="screen_main_04" v-if="screenFlow.StepId === '004'">
        <h1 style="letter-spacing: 0.2rem; text-indent: 0.2rem">颁奖典礼</h1>
        <h3>
          <div v-if="voteResultInfo.VoteName.indexOf('--') !== -1">
            {{
              voteResultInfo.VoteName.substring(
                0,
                voteResultInfo.VoteName.indexOf('--')
              )
            }}
          </div>
          <div v-if="voteResultInfo.VoteName.indexOf('--') === -1">
            {{ voteResultInfo.VoteName }}
          </div>
        </h3>
        <div class="ranking ranking_box" v-if="screenFlow.StepId === '004'">
          <table>
            <tr
              v-for="(item, index) in voteResultInfo.VoteProjectList"
              :key="index"
            >
              <td>
                <div
                  class="ranking-first ranking-item"
                  style="margin-top: 0.38rem"
                >
                  <div class="ranking-top">
                    <div
                      class="ranking-ranking"
                      v-if="voteResultInfo.VoteScreenRankingNum > 0"
                    >
                      <img
                        :src="
                          require('../../../../assets/images/screen_first.png')
                        "
                        v-if="index === 0"
                        v-show="index < voteResultInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_second.png')
                        "
                        v-if="index === 1"
                        v-show="index < voteResultInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_third.png')
                        "
                        v-if="index === 2"
                        v-show="index < voteResultInfo.VoteScreenRankingNum"
                      />
                      <div v-show="index < voteResultInfo.VoteScreenRankingNum">
                        第{{ item.Ranking }}名：
                      </div>
                    </div>
                    <div
                      class="ranking-project-01"
                      style="font-size: 0.52rem; text-align: center"
                    >
                      {{ item.ProjectName }}
                    </div>
                  </div>
                  <div
                    class="ranking-company-01"
                    :class="
                      voteResultInfo.VoteScreenRankingNum > 0
                        ? 'ranking_remark_01'
                        : 'ranking_remark_02'
                    "
                    style="
                      font-size: 0.45rem;
                      text-align: center;
                      margin-top: 0.2rem;
                    "
                  >
                    {{ item.Remark }}
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="height: 1.5rem"></div>
        </div>
      </div>
    </div>
    <div v-show="false">
      <audio
        ref="audio"
        id="audio"
        :src="audioUrl"
        loop="loop"
        @timeupdate="audioTimeUpdate"
      >
        您的浏览器不支持audio标签
      </audio>
      <el-button ref="btnPlay" @click="play">播放</el-button>
    </div>
  </div>
</template>
<script>
import voteManageApi from '../../../../api/vote/voteManage'
import voteApi from '../../../../api/mobileVote/vote'
import screenApi from '../../../../api/mobileVote/screen'
import 'signalr'
import '../../../../assets/js/rem.js'
export default {
  data () {
    return {
      bodyBg: 'screen_body_groupRanking_bg',
      screenFlow: {},
      voteResultInfo: {
        VoteName: '',
        VoteProjectList: []
      },
      completeResultInfo: {
        CurrentVoteName: ''
      },
      conn: {},
      chatHubProxy: {},
      isInit: true,
      audioUrl: require('../../../../../public/audio/screen/颁奖曲.mp3'),
      audio: {
        currentTime: 0
      }
    }
  },
  methods: {
    // 播放音频
    play () {
      const _this = this
      let actualVolumeFadeIn = 0
      _this.$refs.audio.volume = actualVolumeFadeIn
      _this.$refs.audio.play()
      const fadeInInterval = setInterval(function () {
        actualVolumeFadeIn = (parseFloat(actualVolumeFadeIn) + 0.05).toFixed(2)
        if (actualVolumeFadeIn <= 0.6) {
          _this.$refs.audio.volume = actualVolumeFadeIn
        } else {
          clearInterval(fadeInInterval)
        }
      }, 100)
      //   this.$refs.audio.play()
    },
    // 重播
    replay () {
      this.$refs.audio.load()
      this.$refs.audio.play()
    },
    pause () {
      this.$refs.audio.pause()
    },
    audioTimeUpdate: function (res) {
      this.audio.currentTime = res.target.currentTime
    },
    getScreenFlow: function () {
      this.loading = true
      screenApi.getShortlistedScreenFlow({
        voteId: this.$route.params.vid
      }).then(data => {
        this.screenFlow = data
        this.connectionHub()
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    getVoteResult: function () {
      const _this = this
      if (_this.isInit) {
        _this.openLoading()
      }
      voteApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        if (_this.isInit) {
          _this.openLoading().close()
          _this.isInit = false
        }
      }).catch(err => {
        if (_this.isInit) {
          _this.openLoading().close()
        }
        return err
      })
    },
    getShortlistedScreenCompleteResult: function () {
      const _this = this
      _this.openLoading()
      voteApi.getShortlistedScreenCompleteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.completeResultInfo = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getVoteManageResult: function () {
      const _this = this
      // const openLoading = _this.openLoading()
      voteManageApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        // const sendMessage = {
        //   GroupId: null,
        //   IsBegin: null,
        //   MeetingId: _this.$route.params.mid,
        //   ProjectId: null,
        //   StepId: '005',
        //   VoteId: _this.$route.params.vid,
        //   VoteType: 0
        // }
        // _this.chatHubProxy.invoke('sendScreenFlowMessage', _this.$route.params.vid, JSON.stringify(sendMessage))
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        this.$nextTick(function () {
          _this.shortlistedBigScreenSend(data.MeetingId)
        })
        // openLoading.close()
      }).catch(err => {
        // openLoading.close()
        return err
      })
    },
    shortlistedBigScreenSend: function (meetingId) {
      const _this = this
      voteApi.shortlistedBigScreenSend({
        GroupId: null,
        IsBegin: null,
        MeetingId: meetingId,
        ProjectId: null,
        StepId: '005',
        VoteId: _this.$route.params.vid,
        VoteType: 0
      }).then(data => {

      }).catch(err => {
        return err
      })
    },
    getVoteResultRanking: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteManageApi.getVoteResultRanking({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    screenFlowStepChange: function () {
      // MeetingId    GroupId    VoteId     ProjectId    StepId    IsBegin    IsSendMessage
      switch (this.screenFlow.StepId) {
        // case '5':
        //   this.bodyBg = 'screen_body_groupRanking_bg'
        //   this.$nextTick(function () {
        //     this.getGroupRankingInfo()
        //   })
        //   break
        // case '6':
        //   this.bodyBg = 'screen_body_ranking_bg'
        //   this.$nextTick(function () {
        //     this.getGroupRankingInfo()
        //   })
        //   break
        case '001':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_default_bg'
          if (this.screenFlow.VoteType === 0) {
            this.$router.push({ name: 'shortlistedScreen', params: { vid: this.screenFlow.VoteId } })
          }
          if (this.screenFlow.VoteType === 3) {
            this.$router.push({ name: 'largeScreen', params: { vid: this.screenFlow.VoteId } })
          }
          break
        case '002':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_default_bg'
          this.getVoteManageResult()
          break
        case '003':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_groupRanking_bg'
          this.getShortlistedScreenCompleteResult()
          break
        case '004':
          this.$refs.audio.load()
          this.bodyBg = 'screen_body_ranking_bg'
          if (this.screenFlow.VoteId === this.$route.params.vid) {
            this.getVoteResultRanking()
          } else {
            this.$router.push({ name: 'shortlistedScreen', params: { vid: this.screenFlow.VoteId } })
          }
          //   this.$refs.btnPlay.$el.click()
          break
        case '005':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_default_bg'
          break
        case '006':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_groupRanking_bg'
          this.getShortlistedScreenCompleteResult()
          break
        case '6':
          this.$refs.audio.pause()
          this.$router.push({ name: 'largeScreen', params: { vid: this.screenFlow.VoteId } })
          break
      }
    },
    connectionHub: function () {
      const _this = this
      const voteId = _this.$route.params.vid
      const state = JSON.parse(window.localStorage.getItem('state'))
      const token = state.token
      const baseUrl = _this.$config.baseSite

      //   const conn = window.jQuery.hubConnection(baseUrl + '/signalr', { qs: 'access_token=' + token })
      // const conn = window.jQuery.hubConnection(baseUrl + '/signalr', { qs: 'access_token=' + '' })
      // const conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + '' })
      _this.conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + token })
      //   conn.stop() // 如果存在连接，先断开
      _this.chatHubProxy = _this.conn.createHubProxy('screenFlowHub')

      _this.chatHubProxy.on('addRoom', function () {

      })

      _this.chatHubProxy.on('sendScreenFlowMessage', function () { })

      _this.conn.start().done((data) => {
        _this.chatHubProxy.invoke('addRoom', voteId).done((data) => {
          _this.screenFlowStepChange()
          // this.$message({ showClose: true, type: 'success', message: '投票准备就绪' })
        }).fail((msg) => {
          _this.openLoading().close()
          _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
        })
      }).fail((msg) => {
        _this.openLoading().close()
        _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
      })

      _this.conn.error((error) => {
        console.log(error)
      })
      // 重新连接
      _this.conn.reconnected(() => {
        // console.log('重新连接')
      })
      // 当连接已断开连接
      _this.conn.disconnected(() => {
        // console.log('当连接已断开连接')
      })
      // 接收消息
      _this.conn.received((data) => {
        if (data.H && data.M && data.A) {
          if (data.H === 'ScreenFlowHub' && data.M === 'sendScreenFlow' && data.A) {
            const hubMessage = JSON.parse(data.A[0])
            if (hubMessage.StepId) {
              _this.screenFlow = JSON.parse(data.A[0])
              // alert(_this.screenFlow.IsAdmin)
              _this.screenFlowStepChange()
            }
            if (hubMessage.AudioOperate) {
              switch (hubMessage.AudioOperate) {
                case 'play':
                  if (this.$refs.audio.paused) {
                    this.$refs.btnPlay.$el.click()
                    // this.$refs.audio.play()
                  }
                  break
                case 'pause':
                  if (!this.$refs.audio.paused) {
                    let actualVolumeFadeOut = _this.$refs.audio.volume
                    const fadeOutInterval = setInterval(function () {
                      actualVolumeFadeOut = (parseFloat(actualVolumeFadeOut) - 0.05).toFixed(2)
                      if (actualVolumeFadeOut >= 0) {
                        _this.$refs.audio.volume = actualVolumeFadeOut
                      } else {
                        _this.$refs.audio.pause()
                        clearInterval(fadeOutInterval)
                      }
                    }, 100)
                  }
                  break
                case 'replay':
                  this.replay()
                  break
                case 'changeVolume':
                  if (hubMessage.Volume > _this.$refs.audio.volume) {
                    let volumeGradualChange = _this.$refs.audio.volume
                    const volumeGradualChangeInterval = setInterval(function () {
                      volumeGradualChange = (parseFloat(volumeGradualChange) + 0.1).toFixed(2)
                      if (volumeGradualChange <= hubMessage.Volume) {
                        _this.$refs.audio.volume = volumeGradualChange
                      } else {
                        clearInterval(volumeGradualChangeInterval)
                      }
                    }, 100)
                  } else {
                    let volumeGradualChange = _this.$refs.audio.volume
                    const volumeGradualChangeInterval = setInterval(function () {
                      volumeGradualChange = (parseFloat(volumeGradualChange) - 0.1).toFixed(2)
                      if (volumeGradualChange >= hubMessage.Volume) {
                        _this.$refs.audio.volume = volumeGradualChange
                      } else {
                        clearInterval(volumeGradualChangeInterval)
                      }
                    }, 100)
                  }
                  break
              }
            }
          }
        }
      })

      // 当客户端检测到慢速或频繁删除连接时引发
      _this.conn.connectionSlow(() => {
        // console.log('当客户端检测到慢速或频繁删除连接时引发')
      })
    }
  },
  mounted () {
    this.getScreenFlow()
  },
  created () {

  },
  beforeDestroy () {
    this.conn.stop()
  },
  watch: {
    $route () {
      this.conn.stop()
      this.isInit = true
      this.getScreenFlow()
    }
  }
}
</script>

<style lang="less">
html,
body {
  height: 100%;
}

/* 图片自适应 */
img {
  width: 100%;
  height: auto;
  width: auto9; /* ie8 */
  display: block;
  -ms-interpolation-mode: bicubic; /*为了照顾ie图片缩放失真*/
}
img {
  border: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}
.screen_body {
  width: 100%;
  height: 100%;
  font-family: SimSun, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.screen_body_default_bg {
  background: url('../../../../assets/images/screenBg_03.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_score_bg {
  background: url('../../../../assets/images/screenBg_01.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_groupRanking_bg {
  background: url('../../../../assets/images/screenBg_04.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_ranking_bg {
  background: url('../../../../assets/images/screenBg_02.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_content {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

.screen_content_center {
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.screen_main {
  width: 100%;
  flex-grow: 2;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.screen_main_01 {
  align-self: center;
  width: 12rem;
  font-size: 0.6rem;
  color: #fff;
  height: 5rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.screen_main_01 .remark {
  padding: 50px 0px 0px 0px;
  font-size: 0.5rem;
  font-family: kaiti;
  flex-grow: 1;
}
.screen_main_02 {
  height: 100%;
  width: 14rem;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
}
.screen_main_02 h1 {
  /* color: #fbfa7d; */
  font-size: 0.4rem;
  text-align: center;
  margin-top: 0.75rem;
  height: 1rem;
  line-height: 0.5rem;
}
.jury {
  display: flex;
  justify-content: space-between;
  width: 4.66rem;
  margin: 0.3rem auto;
}
.jury > div {
  font-size: 0.35rem;
}
.result-show {
  display: flex;
  flex-wrap: wrap;
}
.result-show-item {
  width: 1.5rem;
  height: 2.25rem;
  border: 1px dotted #acdbf5;
  margin: 0.1rem;
}
.result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
.result-show-item img {
  width: 1.2rem;
}
.result-show-item .item-img {
  width: 1.2rem;
  height: 1.6rem;
  margin-top: 8px;
}
.result-show-item .item-name {
  width: 1.2rem;
  height: 0.3rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.result-show-item .item-number {
  width: 1.2rem;
  height: 0.3rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}
.item10 {
  width: 9rem;
  margin: 0 auto;
}
.item24 {
  width: 14rem;
  margin: 0 auto;
}
.item30 {
  width: 13.4rem;
  margin: 0 auto;
}
.item30 .result-show-item {
  width: 1.2rem;
  height: 2rem;
  border: 1px dotted #acdbf5;
  margin: 0.05rem;
}
.item30 .result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
.item30 .result-show-item img {
  width: 1rem;
}
.item30 .result-show-item .item-img {
  width: 1rem;
  height: 1.33rem;
}
.item30 .result-show-item .item-name {
  width: 1rem;
  height: 0.3rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.item30 .result-show-item .item-number {
  width: 1rem;
  height: 0.3rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}
.item40 {
  width: 13.5rem;
  margin: 0 auto;
}
.item40 .result-show-item {
  width: 1rem;
  height: 1.62rem;
  border: 1px dotted #acdbf5;
  margin: 0.05rem;
}
.item40 .result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.24rem;
  font-size: 0.16rem;
  text-align: center;
}
.item40 .result-show-item img {
  width: 0.8rem;
}
.item40 .result-show-item .item-img {
  width: 0.8rem;
  height: 1.07rem;
}
.item40 .result-show-item .item-name {
  width: 0.8rem;
  height: 0.24rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.item40 .result-show-item .item-number {
  width: 0.8rem;
  height: 0.24rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}

.screen_main_03 {
  height: 100%;
  width: 13rem;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
  padding: 0 1rem;
  font-family: simhei, 'times new roman';
}
.screen_main_03 h1 {
  /* color: #fbfa7d; */
  font-size: 0.7rem;
  text-align: center;
  margin-top: 0.6rem;
}

.screen_main_04 {
  height: 100%;
  width: 12.6rem;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
  padding: 0 1rem;
  font-family: simhei, 'times new roman';
}
.screen_main_04 h1 {
  color: #fbfa7d;
  font-size: 0.7rem;
  text-align: center;
  margin-top: 0.9rem;
}
.screen_main_04 h3 {
  color: #fff;
  font-size: 0.46rem;
  text-align: center;
  margin-top: 0.3rem;
}
.screen_main_03 .ranking_box {
  height: e('calc(100% - 2.2rem)');
  cursor: default;
}
.screen_main_03 .ranking_box:hover {
  height: e('calc(100% - 2.2rem)');
  cursor: default;
  background-color: rgba(255, 255, 255, 0.1);
  //opacity: 0.1;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.1);
}
.screen_main_04 .ranking_box {
  height: e('calc(100% - 3.3rem)');
  cursor: default;
}
.screen_main_04 .ranking_box:hover {
  height: e('calc(100% - 3.3rem)');
  cursor: default;
  background-color: rgba(255, 255, 255, 0.1);
  //opacity: 0.1;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.1);
}
.ranking {
  padding: 0rem 0.3rem;
  overflow-y: auto;
  margin-top: 0.2rem;
  font-size: 0.4rem;
  color: #fff;
}
.ranking::-webkit-scrollbar {
  display: none; /*隐藏滚动条*/
}
.ranking table {
  margin: 0 auto;
}
.ranking img {
  width: 0.5rem;
}
.ranking-item {
  margin-top: 0.23rem;
}
.ranking-top {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.05rem 0;
}
.ranking-ranking {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 2.4rem;
}
.ranking-ranking img {
  margin-right: 15px;
}
.ranking-ranking .rankingIndex {
  width: 60px;
}
.ranking-project {
  width: 10rem;
}
.ranking-company {
  display: flex;
  justify-content: space-between;
  font-size: 0.32rem;
  margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
}
.ranking-company .name {
  padding-right: 10px;
}
.ranking-company .score {
  align-self: flex-end;
  flex-shrink: 0;
}
.ranking-company .score span {
  color: #f40c0c;
}

.ranking_score_box {
  font-size: 0.32rem;
  //   margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.ranking_score_box .ranking_score_item {
  margin-left: 20px;
  white-space: nowrap;
}

.ranking_score_box .ranking_score_item span {
  color: #f40c0c;
}

.ranking-project-01 {
  max-width: 9rem;
}
.ranking-company-01 {
  font-size: 0.32rem;
  margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
}
.ranking_remark_01 {
  font-size: 0.32rem;
  margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
}
.ranking_remark_02 {
  font-size: 0.32rem;
  margin-left: 0rem;
  font-family: kaiti;
  font-weight: bold;
}
.screen_main_01 .screen_main_score_item {
  font-size: 0.4rem;
  width: 3.6rem;
  align-self: center;
  text-align: left;
  margin-left: 0.6rem;
  margin-bottom: 0.15rem;
}
.screen_main_01 .screen_main_score_item span {
  color: #f40c0c;
  font-weight: 700;
  font-family: cursive;
}

.screen_main_01 .screen_main_score {
  //padding: 150px 0px 0px 0px;
  text-align: center;
}
.screen_main_01 .screen_main_score span {
  color: #f40c0c;
  font-weight: 700;
  font-family: cursive;
}
.screen_main_01 .screen_main_score i {
  //font-size: 30px;
  font-size: 0.45rem;
  vertical-align: top;
  cursor: pointer;
}
.screen_foot {
  width: 100%;
  height: 100px;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.detail_final_score {
  width: 100%;
  text-align: right;
  margin: 15px 0px 0px;
  vertical-align: middle;
}
.detail_final_score span {
  font-size: 0.4rem;
  font-weight: 600;
}
.score_detail_dialog {
  font-size: 0.18px;
}
.score_detail_dialog .el-dialog__header .el-dialog__title {
  font-size: 0.3rem;
}
.score_detail_dialog .el-dialog__header button {
  font-size: 0.2rem;
}
.score_detail_dialog .el-dialog__body {
  font-size: 0.2rem;
}
.score_detail_dialog .el-dialog__body .el-table {
  font-size: 0.18rem;
}
.score_detail_dialog .el-dialog__footer button {
  font-size: 0.15rem;
}
</style>
